const state = {
  // se inicializa con la acción initContentCommentThread
  contentId: null,
  comments: [],
  partnerComments: [],
  featuredComment: null,
  totalComments: null,
  pages: 0,
  currentPage: 0,
  // Sólo tienen valor cuando se responde a un usuario.
  replyingCommentId: null,
  replyingUserId: null,
  replyingUserNick: null,
  // Usuarios muteados
  mutedUsers: [],
  // Mapa -> Número : Array<{ userNick: string, userProfileUrl: string }>
  commentUserLikes: {},
  // para formar los parámetros para la petición GET de recuperar comentarios
  filters: {
    orderBy: 'relativeCommentIdDesc',
    page: 1
  },
  // Para representar los comentarios a los que el usuario ha dado like
  userLikedCommentIds: [],
};

export default state;
